import { Typography } from '@sravni/react-design-system';
import type { TextProps } from '@sravni/react-design-system/dist/types/components/Typography/types/Text.types';
import { useIsMobile } from '@sravni/react-utils';
import cn from 'classnames';
import type { FC } from 'react';

import styles from './AdaptiveText.module.scss';

interface IAdoptiveSubtitleTextProps {
  className?: string;
  range?: [TextProps['size'], TextProps['size']];
  truncate?: boolean;
  nowrap?: boolean;
}

const DEFAULT_RANGE: [TextProps['size'], TextProps['size']] = [12, 14];

export const AdaptiveSubtitleText: FC<IAdoptiveSubtitleTextProps> = ({
  range = DEFAULT_RANGE,
  children,
  className = 'h-color-D60',
  truncate,
}) => {
  const isMobile = useIsMobile();

  return (
    <Typography.Text
      size={isMobile ? range[0] : range[1]}
      className={cn(styles.adaptiveText, className)}
      truncate={truncate}
    >
      {children}
    </Typography.Text>
  );
};
